import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import authUser from './auth-user';
import schoolProfile from './school/school-profile';
import schoolSettings from './school/school-settings';
import schoolUsers from './school/school-users';
import schoolQuestions from './school/school-questions';
import schoolVacancies from './school/school-vacancies';
import vacancyQuestions from './vacancies/vacancy-questions';
import vacancyDetails from './vacancies/vacancy-details';
import vacancyClose from './vacancies/vacancy-close';
import { reducer as toastr } from 'react-redux-toastr';
import { reducer as idle } from '../tools/idle-monitor';
import userProfile from './user-account/user-profile';
import forgotPassword from './password-recovery/forgot-password';
import schoolPublicVacancies from './school/school-public-vacancies';
import userActivation from './user-activation/user-activation';
import confirmUserActivation from './user-activation/confirm-user-activation';
import userSignIn from './user-sign-in/user-sign-in';
import vacancyApplications from './vacancies/vacancy-applications';
import schoolPublicVacancy from './school/school-public-vacancy';
import schoolPublicVacancyPrescreeningQuestions from './school/school-public-vacancy-prescreening-questions';
import schoolPublicVacancyApplication from './school/school-public-vacancy-application';
import resetPassword from './password-recovery/reset-password';
import candidateApplicationList from './candidate/candidate-applications/candidate-application-list';
import applicationRatings from './applications/application-ratings';
import applicationComments from './applications/application-comments';
import candidateMoreVacanciesList from './candidate/candidate-more-vacancies/candidate-more-vacancies-list';
import schoolCandidateReferences from './school/school-candidate-references';
import candidateReferences from './candidate/candidate-references/candidate-references';
import references from './references/references';
import applicationDetails from './applications/application-details';
import candidateApplication from './candidate/candidate-application/candidate-application';
import candidateApplicationDraft from './candidate/candidate-application/candidate-application-draft';
import candidateProfile from './candidate/candidate-profile/candidate-profile';
import schoolCandidateComments from './school/school-candidate-comments';
import schoolCandidateProfile from './school/school-candidate-profile';
import schoolCandidateApplicationHistory from './school/school-candidate-application-history';
import schoolAdminEmails from './school-admin/emails';
import schoolCandidate from './school/school-candidate';
import schoolPriorCandidates from './school/school-prior-candidates';
import applicationsComparison from './candidate/candidate-applications/comparison';
import vacancyDuplication from './vacancies/vacancy-duplication';
import schoolAdminQuestionPool from './school-admin/question-pool';
import adminSchools from './admin/admin-schools';
import adminAudit from './admin/admin-audit';
import adminUsers from './admin/admin-users';
import candidateProfileRevisionsComparison from './candidate/candidate-profile-revision/comparison';
import userChangePassword from './user-account/user-change-password';
import adminUsersCandidateProfile from './admin/users/candidates/admin-users-candidate-profile';
import vacancyDocuments from './vacancies/vacancy-documents';
import candidateApplicationDocuments from './candidate/candidate-application/candidate-application-documents';
import candidateDocumentTypes from './candidate/candidate-document-types';
import candidateProfileDocuments from './candidate/candidate-profile/candidate-profile-documents';
import schoolCandidatePartnerProfile from './school/school-candidate-partner';
import userAccountSettings from './user-account/user-account-settings';
import schoolDashboard from './school/school-dashboard';
import candidateLinkSearchAssociatesAccount from './candidate/candidate-link-search-associates-account';
import userChangeEmail from './user-account/user-change-email';
import listSettings from './list-settings';
import vacancyAccess from './vacancies/vacancy-access';
import schoolReleaseInfo from './school/school-release-info';

export default combineReducers({
  authUser,
  schoolProfile,
  schoolSettings,
  schoolUsers,
  schoolQuestions,
  schoolVacancies,
  vacancyQuestions,
  vacancyDetails,
  vacancyClose,
  userProfile,
  forgotPassword,
  resetPassword,
  schoolPublicVacancies,
  userActivation,
  userSignIn,
  confirmUserActivation,
  vacancyApplications,
  schoolPublicVacancy,
  schoolPublicVacancyPrescreeningQuestions,
  schoolPublicVacancyApplication,
  applicationRatings,
  form,
  toastr,
  idle,
  candidateApplicationList,
  candidateMoreVacanciesList,
  schoolCandidateReferences,
  candidateReferences,
  references,
  applicationDetails,
  candidateApplication,
  candidateApplicationDraft,
  candidateProfile,
  applicationComments,
  schoolCandidateComments,
  schoolCandidateProfile,
  schoolCandidateApplicationHistory,
  schoolAdminEmails,
  schoolCandidate,
  schoolPriorCandidates,
  applicationsComparison,
  adminSchools,
  schoolAdminQuestionPool,
  adminAudit,
  candidateProfileRevisionsComparison,
  vacancyDuplication,
  userChangePassword,
  adminUsersCandidateProfile,
  adminUsers,
  vacancyDocuments,
  candidateDocumentTypes,
  candidateApplicationDocuments,
  candidateProfileDocuments,
  schoolCandidatePartnerProfile,
  userAccountSettings,
  schoolDashboard,
  candidateLinkSearchAssociatesAccount,
  userChangeEmail,
  listSettings,
  vacancyAccess,
  schoolReleaseInfo
});



// WEBPACK FOOTER //
// ./src/reducers/index.js